var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOpenLink = function SvgOpenLink(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33124 2.83341C2.15131 2.83341 1.99984 2.98144 1.99984 3.16891V13.1646C1.99984 13.3506 2.1495 13.5001 2.33534 13.5001H12.331C12.5196 13.5001 12.6665 13.3497 12.6665 13.1687V9.50008C12.6665 9.13189 12.965 8.83341 13.3332 8.83341C13.7014 8.83341 13.9998 9.13189 13.9998 9.50008V13.1687C13.9998 14.0901 13.2519 14.8334 12.331 14.8334H2.33534C1.41421 14.8334 0.666504 14.088 0.666504 13.1646V3.16891C0.666504 2.24942 1.41058 1.50008 2.33124 1.50008H5.99984C6.36803 1.50008 6.6665 1.79856 6.6665 2.16675C6.6665 2.53494 6.36803 2.83341 5.99984 2.83341H2.33124Z",
    fill: "#8290A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4712 1.02868C14.7316 1.28903 14.7316 1.71114 14.4712 1.97149L8.47124 7.97149C8.21089 8.23184 7.78878 8.23184 7.52843 7.97149C7.26808 7.71114 7.26808 7.28903 7.52843 7.02868L13.5284 1.02868C13.7888 0.768327 14.2109 0.768327 14.4712 1.02868Z",
    fill: "#8290A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33317 0.833415C9.33317 0.465225 9.63165 0.166748 9.99984 0.166748H14.6665C15.0347 0.166748 15.3332 0.465225 15.3332 0.833415V5.50008C15.3332 5.86827 15.0347 6.16675 14.6665 6.16675C14.2983 6.16675 13.9998 5.86827 13.9998 5.50008V1.50008H9.99984C9.63165 1.50008 9.33317 1.2016 9.33317 0.833415Z",
    fill: "#8290A2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOpenLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/open-link.24acaaad.svg";
export { ForwardRef as ReactComponent };